export var LiveRedirect = LiveRedirect || {};

export var HUYA = HUYA || {};

LiveRedirect.GetShareShortLinkReq = function () {
  this.tId = new HUYA.UserId();
  this.sUrl = "";
  this.iLevel = 0;
  this.sBusiness = "";
  this.sUrlPrefix = "";
  this.sUrlSuffix = "";
};

LiveRedirect.GetShareShortLinkReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.sUrl = is.readString(1, false, this.sUrl);
  this.iLevel = is.readInt32(2, false, this.iLevel);
  this.sBusiness = is.readString(3, false, this.sBusiness);
  this.sUrlPrefix = is.readString(4, false, this.sUrlPrefix);
  this.sUrlSuffix = is.readString(5, false, this.sUrlSuffix);
};

LiveRedirect.GetShareShortLinkReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeString(1, this.sUrl);
  os.writeInt32(2, this.iLevel);
  os.writeString(3, this.sBusiness);
  os.writeString(4, this.sUrlPrefix);
  os.writeString(5, this.sUrlSuffix);
};

LiveRedirect.GetShareShortLinkReq.prototype._clone = function () {
  return new LiveRedirect.GetShareShortLinkReq();
};
LiveRedirect.GetShareShortLinkReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
LiveRedirect.GetShareShortLinkReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserId = function () {
  this.lUid = 0;
  this.sGuid = "";
  this.sToken = "";
  this.sHuYaUA = "";
  this.sCookie = "";
  this.iTokenType = 0;
  this.sDeviceInfo = "";
};

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
};

HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
  os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId();
};
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

LiveRedirect.GetShareShortLinkResp = function () {
  this.sShotUrl = "";
};

LiveRedirect.GetShareShortLinkResp.prototype.readFrom = function (is) {
  this.sShotUrl = is.readString(0, false, this.sShotUrl);
};

LiveRedirect.GetShareShortLinkResp.prototype.writeTo = function (os) {
  os.writeString(0, this.sShotUrl);
};

LiveRedirect.GetShareShortLinkResp.prototype._clone = function () {
  return new LiveRedirect.GetShareShortLinkResp();
};
LiveRedirect.GetShareShortLinkResp.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
LiveRedirect.GetShareShortLinkResp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};
